import Post from 'store/models/post';
import { GET_POST, GET_BLOG, GET_FEATURED } from './actions';

const initialState = {
  /**
   * List of featured posts
   */
  featured: [],

  /**
   * List of pinned posts
   */
  pinned: [],

  /**
   * List of published posts
   */
  posts: {
    total: 0,
    list: [],
  },

  /**
   * The current post to see
   */
  post: new Post(),
};

export default function reducer(state = initialState, action) {
  switch(action.type) {
    case GET_POST.SUCCESS:
      return {
        ...state,
        post: action.payload.blog,
      };
    case GET_FEATURED.SUCCESS:
      return {
        ...state,
        featured: action.payload.featured.slice(0, 3),
        pinned: action.payload.featured.slice(3),
      };
    case GET_BLOG.SUCCESS:
      return {
        ...state,
        posts: {
          total: action.payload.meta.total,
          list: action.payload.blog,
        },
      };
    default:
      return state;
  }
}
